export const ContentIDConstants = {
  question: 0,
  tooltip: 1,
};
